// extracted by mini-css-extract-plugin
export default {"module":"ModuleWrapper_module__isT7X","moduleMargin":"ModuleWrapper_moduleMargin__qZTc+"};